import useSWR from "swr"

export interface KarbonUserData {
  displayName: string;
  emailAddress: string;
  userProfilePermaKey: string;
  userPublicKey: string;
  userPublicKeyHash: string;
  tenantPermaKey: string;
  dataCenterUrl: string;
  isAdmin: boolean;
}


export interface KarbonUserInfo {
  data: KarbonUserData | Partial<KarbonUserData>
  errors: Error | {}
  isLoggedIn: boolean
}

// example data
// {"displayName":"Jess Gomes-Ng","emailAddress":"jess@karbonhq.com","userProfilePermaKey":"2p3WRH5MGXXX","tenantPermaKey":"KWfygPXXXX","dataCenterUrl":"https://stage.karbonhq.com","isAdmin":true}

const config = {
  revalidateOnFocus: true,
  shouldRetryOnError: false,
}

let apiEndpoint = "https://us3.karbonhq.com"

if (process.env.GATSBY_DEPLOY_ENV === "live") {
  apiEndpoint = "https://us3.karbonhq.com"
}

if (process.env.GATSBY_DEPLOY_ENV === "stage") {
  apiEndpoint = "https://stage.karbonhq.com"
}
if (process.env.GATSBY_DEPLOY_ENV === "test") {
  apiEndpoint = "https://test.karbonhq.com"
}

export function useKarbonUserData(): KarbonUserInfo {
  const fetcher = async () => {
    if (apiEndpoint) {
      return fetch(`${apiEndpoint}/api/currentUser`, {
        credentials: "include",
      })
          .then(res => {
            let returnData

            if (res.status === 200) {
              const isJson = res.headers
                  .get("content-type")
                  ?.includes("application/json")

              returnData = isJson ? res.json() : null

              if (!res.ok) {
                const err = (returnData && returnData.message) || res.status

                return Promise.reject(err)
              }
            }

            return returnData
          })
          .catch(err => {
            console.error("There was an error!", err)
            throw new Error(err)
          })
    }
  }

  const { data, error }: { data?: KarbonUserData; error?: Error } = useSWR(
    "karbonapp",
    fetcher,
    config
  )

  return {
    data: data || {},
    errors: error || {},
    isLoggedIn: !!data?.userProfilePermaKey && !!data?.dataCenterUrl,
  }
}
